// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"653":"amzn","792":"main"}[chunkId] + "." + {"653":"a214b8e4","792":"c4162309"}[chunkId] + ".css";
};